<template>
<vs-dropdown vs-custom-content vs-trigger-hover class="cursor-pointer">
  <div class="the-navbar__user-meta flex items-center" v-if="user.uid">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ user.nickName }}</p>
      <small>{{user.userName}}【{{$s.dict.roleName[user.roleID]}}】</small>
    </div>

    

      <div class="con-img ml-3">
        <img v-if="user.avatarUrl" key="onlineImg" :src="user.avatarUrl" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/pages/setting')">
            <icon icon="user" svgClasses="w-4 h-4" />
            <span class="ml-2">用户设置</span>
          </li>
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">注销登录</span>
          </li>
        </ul>
      </vs-dropdown-menu>
  </div>
</vs-dropdown>
</template>

<script>
// import firebase from 'firebase/app'
// import 'firebase/auth'

export default {
  data() {
    return {

    }
  },
  $computed: {
    user: 'auth.user'
  },
  methods: {
    logout() {
      this.$s.auth.logout().then(user => {
        return this.$router.push(this.$acl.check('admin') ? '/pages/login/admin' : '/pages/login')
      })
    },
  }
}
</script>
